import React,{useState,useRef} from 'react'
import {useAuth} from './AuthContext'
import {Link,useHistory} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope,faLock } from '@fortawesome/free-solid-svg-icons'
import swal from 'sweetalert'
import './Util.css'
import './Main.css'

export default function Signup() {
    const emailRef=useRef();
    const passwordRef=useRef();
    const passwordConfrimRef=useRef();
    const userRef=useRef()
    const {signup} =useAuth()
    const [error,setError]=useState();
    const [loding,setLoading]=useState(false);
    const history=useHistory()
    async function handleSubmit(e){
        e.preventDefault();
        if(passwordRef.current.value!=passwordConfrimRef.current.value){
            alert("password dont match")
            return setError("password dont match");
        }
        try{
            setError('')
            setLoading(true)
            await signup(emailRef.current.value,passwordRef.current.value)
            swal({
                title:"Registerd",
                icon:"success",
                button:"login",
            })
            history.push("./login")
        }catch (err){
            swal({
                title:err.message,
                text:"enter valid mail or password",
                icon:"warning",
                button:"ok",
            })
            setError(err.message)
        }
        setLoading(false)
    }
    return (
        <section>
			<div id="container"></div>
				<div id="subcontainer">
						
						<form autoComplete="off">
                        <h2>Sign up</h2>
                        <div id="hul"></div>
                        
							<div className="inputbox">
								
								<input type="email" ref={emailRef} placeholder="E-mail" required></input>
								<span class="focus-input100"></span>
								<span class="symbol-inputE">
								<FontAwesomeIcon icon={faEnvelope} />
								</span>
								
							</div>
							<div className="inputbox">
								<input type="password" placeholder="password" ref={passwordRef} required></input>
								<span class="focus-input100"></span>
								<span class="symbol-inputP">
								<FontAwesomeIcon icon={faLock} />
								</span>
							</div>
                            <div className="inputbox">
								<input type="password" placeholder="confrim password" ref={passwordConfrimRef} required></input>
								<span class="focus-input100"></span>
								<span class="symbol-inputCP">
								<FontAwesomeIcon icon={faLock} />
								</span>
							</div>
                            
							<div className="inputbox">
								<button disabled={loding} onClick={handleSubmit}> Sign Up </button>
							</div>
                            <div id="fp">
							<p>Forget Password ? <Link to="./resetpassword">Reset</Link></p>
							<p>Already have account <Link to="/login">log in</Link></p>
                            </div>
						</form>
			</div>
		</section>

    )
}
